<template>
  <div class="main">
    <img v-if="$route.query.type == 'economy'" src="@/assets/img/economy/economy.png" />
    <img v-if="$route.query.type == 'track'" src="@/assets/img/economy/track.png" />
    <img v-if="$route.query.type == 'output'" src="@/assets/img/economy/output.png" />
    <img v-if="$route.query.type == 'traffic'" src="@/assets/img/economy/traffic.png" />
    <img v-if="$route.query.type == 'resources'" src="@/assets/img/economy/resources.png" />
  </div>
</template>

<script>
export default {
  name: "Economy",
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$wow.init();

  },
  methods: {},
};
</script>

<style lang="scss" scoped>
// @import "../../assets/customAnimation.css";
.main {
  // margin-top: 60px;

  >div {
    width: 100%;
    background-size: cover;
  }

  img {
    width: 99vw;
    position: relative;
    top: -20px;
  }
}
</style>
